import { useEffect } from "react";
import { logout } from "../firebase/firebase";

function SignOutView() {
  useEffect(() => {
    logout();
  }, []);

  return null;
}

export { SignOutView };